// Centraliseret data for alle cases
// Bruges af Cases.jsx (oversigt) og CaseDetail.jsx (detaljer)

export const cases = [
  {
    id: 1,
    slug: 'magasin',
    title: 'Magasin',
    category: 'Facade',
    client: 'Magasin',
    location: 'København & Aarhus',
    year: '2019-2024',
    description: 'Vi har leveret julebelysning til syv varehuse på tværs af landet, med København og Aarhus som de største installationer. Projektet strækker sig over fem år og stiller høje krav til koordinering, præcis opmåling af facader og udvikling af specialdesignede løsninger. En del af den eksisterende belysning er genanvendt, hvilket har været med til at optimere både økonomi og ressourcer.',
    services: ['Julebelysning', 'Facadebelysning', 'Projektledelse', 'Specialdesign'],
    image: 'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/jse50k8b_251206_NEONSIGN_CHP-160.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/jse50k8b_251206_NEONSIGN_CHP-160.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/kdwwh024_251206_NEONSIGN_CHP-167.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/pdusikmj_251206_NEONSIGN_CHP_DRONE-8.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/6abk1a5g_251125_NeonSign_aarhus_m3--11.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/6ilispiz_251125_NeonSign_aarhus-13.jpg',
    ],
  },
  {
    id: 2,
    slug: 'public',
    title: 'Public',
    category: 'LED',
    client: 'Public / ACT Arkitekter',
    location: 'København',
    year: '2024',
    description: 'I tæt samarbejde med ACT Arkitekter har vi leveret en specialtilpasset belysningsløsning til Public – et af Danmarks højeste kontorhoteller. Projektet krævede en særlig varm hvid LED, som ikke er standard, og som vi løste gennem specialfiltre integreret i bogstaverne. Derudover udvikler vi wayfinding-løsninger til lobbyen i samarbejde med arkitekterne.',
    services: ['LED-bogstaver', 'Specialfiltre', 'Wayfinding', 'Arkitektsamarbejde'],
    image: 'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/hgw39q5e_251206_NEONSIGN_CHP-211.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/hgw39q5e_251206_NEONSIGN_CHP-211.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/lkeb2gk9_251206_NEONSIGN_CHP-203.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/lpi6obcc_251206_NEONSIGN_CHP-212.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/5jxa1gzi_251206_NEONSIGN_CHP-229.jpg',
    ],
  },
  {
    id: 3,
    slug: 'kodbyen',
    title: 'Kødbyen',
    category: 'Neon',
    client: 'Diverse restauranter',
    location: 'Kødbyen, København',
    year: '2018-2024',
    description: 'Vi har leveret neonskiltning til en række markante lokationer i Kødbyen, herunder restauranter som Masseria, Gorilla, Ismageriet, Baggen, Danza, Bambi og Soho. Projekterne kræver stor forståelse for områdets restriktioner, hvor installationer skal tilpasses eksisterende facader, og føringer skjules så diskret som muligt.',
    services: ['Ægte glasneon', 'Facadetilpasning', 'Diskret føring', 'Specialinstallation'],
    image: 'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/k85en2og_251206_NEONSIGN_CHP-9.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/k85en2og_251206_NEONSIGN_CHP-9.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/lm0cu13t_251206_NEONSIGN_CHP-17.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/agbpzpi6_251206_NEONSIGN_CHP-24-kopi.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/jyzu4471_251206_NEONSIGN_CHP-42.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/hapxlavt_251206_NEONSIGN_CHP-55.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/0657qx8u_251206_NEONSIGN_CHP-42.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/0sld50ox_251206_NEONSIGN_CHP-47.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/gw3n85gp_251206_NEONSIGN_CHP-68-kopi.jpg',
    ],
  },
  {
    id: 4,
    slug: 'next-house',
    title: 'Next House',
    category: 'Wayfinding',
    client: 'Next House / Lilly',
    location: 'København',
    year: '2024',
    description: 'Til Next House har vi udviklet og leveret wayfinding-løsninger gennem hele bygningen – fra stueetage til 8. sal. Skiltningen består af store plader og folietekster på vægge samt udvendig wayfinding. Derudover har vi leveret lejerskiltning i tæt samarbejde med blandt andet Lillys designteam.',
    services: ['Wayfinding', 'Skiltsystemer', 'Folietekster', 'Lejerskiltning'],
    image: 'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/rj58t58v_20251217_113935%20%281%29.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/rj58t58v_20251217_113935%20%281%29.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/vldgeel8_20251217_114131.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/sovudm6p_20251217_114008%20%28redigeret%29.jpg',
    ],
  },
  {
    id: 5,
    slug: 'cabinn',
    title: 'Cabinn Skiltning',
    category: 'Wayfinding',
    client: 'Cabinn Hotels',
    location: 'Danmark',
    year: '2018-2024',
    description: 'Vi har gennem mange år leveret skilteløsninger til Cabinn Hotels – fra udendørs lysskilte til indvendig wayfinding. Projekterne tæller blandt andet Cabinn Copenhagen og flere hoteller i hele landet. Samtidig har vi været med til at sikre korrekt anvendelse af brandets visuelle identitet på tværs af lokationer.',
    services: ['Wayfinding', 'Lysskilte', 'Brand identity', 'Systemleverance'],
    image: 'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/xbr9cv6k_Cabinn%20Copenhagen.png',
    gallery: [
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/xbr9cv6k_Cabinn%20Copenhagen.png',
    ],
  },
  {
    id: 6,
    slug: 'politikens-hus',
    title: 'Politikens Hus',
    category: 'Facade',
    client: 'Politiken',
    location: 'København',
    year: '2005-2024',
    description: 'Projektet er oprindeligt udført for næsten 20 år siden i samarbejde med et arkitektfirma. Vi har leveret neonrør og røde bogstaver, og arbejder i dag med opdatering og udskiftning til nye LED-løsninger. Fokus er både energiforbedring og vedligeholdelse af den eksisterende skiltning.',
    services: ['Neonrør', 'LED-opgradering', 'Vedligeholdelse', 'Facadeskilte'],
    image: 'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/kqz604ps_251206_NEONSIGN_CHP-238.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/kqz604ps_251206_NEONSIGN_CHP-238.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/fgycazc5_251206_NEONSIGN_CHP-233.jpg',
    ],
  },
  {
    id: 7,
    slug: 'bremen-kolme',
    title: 'Bremen / Kolme',
    category: 'LED',
    client: 'Bremen & Kolme',
    location: 'København',
    year: '2023',
    description: 'Til Bremen har vi arbejdet med facadeudtryk inspireret af klassiske Broadway-teatre, med LED-lys og bogstaver med rød outline. For Kolme har vi udviklet udhæng med lyseffekter og aluminiumsskilte, hvor både form og lys spiller sammen i et markant visuelt udtryk.',
    services: ['LED-belysning', 'Aluminiumsskilte', 'Udhæng', 'Facadedesign'],
    image: 'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/k216nwkp__DSC3835.jpg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/k216nwkp__DSC3835.jpg',
      'https://customer-assets.emergentagent.com/job_82f36689-5905-4eb9-a410-52f80a0daaf2/artifacts/ft892osm__DSC3829.jpg',
    ],
  },
];

// Kategorier til filtrering
export const categories = ['Alle', 'Facade', 'LED', 'Neon', 'Wayfinding'];

// Helper til at finde case by id eller slug
export const getCaseById = (id) => cases.find(c => c.id === parseInt(id) || c.slug === id);

// Helper til at få næste/forrige case
export const getAdjacentCases = (currentId) => {
  const index = cases.findIndex(c => c.id === parseInt(currentId));
  return {
    prev: index > 0 ? cases[index - 1] : cases[cases.length - 1],
    next: index < cases.length - 1 ? cases[index + 1] : cases[0],
  };
};
